const _i18n_info = {
  path : {
    EN: `path refresh`,
    KO: `path refresh`,
    JP: `パスのリフレッシュ`
  }
}

const _i18n_warning = {
  scan_list : {
    EN: `no have monitoring folder`,
    KO: `no have monitoring folder`,
    JP: `監視フォルダーはありません`
  },
  scan_list_2 : {
    EN: `Monitoring folder not included #path`,
    KO: `Monitoring folder not included #path`,
    JP: `監視フォルダーは含まれていません #path`
  },
  scan_list_3 : {
    EN: `Monitoring folder not included #path-drop`,
    KO: `Monitoring folder not included #path-drop`,
    JP: `監視フォルダーは含まれていません #path-drop`
  },
  scan_list_4 : {
    EN: `Monitoring folder not included #file-drop`,
    KO: `Monitoring folder not included #file-drop`,
    JP: `監視フォルダーは含まれていません #file-drop`
  },
  scan_list_5 : {
    EN: `Monitoring folder not included #file`,
    KO: `Monitoring folder not included #file`,
    JP: `監視フォルダーは含まれていません #file`
  }
}

const i18n_toastr = {
  _i18n_info,
  _i18n_warning
}

export default i18n_toastr